const NAMES = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion'];

export const formatCoins = (n) => {
  n = Math.floor(n);
  if (n < 1e6) return n.toLocaleString();
  const tier = Math.min(Math.floor(Math.log10(n) / 3), NAMES.length - 1);
  return `${(n / 10 ** (tier * 3)).toFixed(3)} ${NAMES[tier]}`;
};

export const formatCps = (n) =>
  n < 100
    ? (Math.round(n * 10) / 10).toLocaleString(undefined, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })
    : formatCoins(n);